module.exports = __webpack_public_path__ + "static/media/icon-arrow-up.c43bde2e.svg";